import TranslationService from 'ceres/app/services/TranslationService';
const NotificationService = require('ceres/app/services/NotificationService');

Vue.component('checkout-invoice-address-select', {

    delimiters: ['${', '}'],

    props: [
        'selectedAddressId',
        'addressList',
        'hasToValidate',
        'template'
    ],

    computed: Vuex.mapState({
        billingAddressId: state => state.address.billingAddressId,
        showError: state => state.checkout.validation.invoiceAddress.showError
    }),

    created() {

        this.$options.template = this.template;

        this.$store.dispatch('initBillingAddress', {id: this.selectedAddressId, addressList: this.addressList});

        if (this.hasToValidate) {
            this.$store.commit('setInvoiceAddressValidator', this.validate);
        }
    },

    methods: {

        addressChanged(selectedAddress) {

            this.$store.dispatch('selectAddress', {selectedAddress, addressType: '1'})
                .then(response => {
                    document.dispatchEvent(new CustomEvent('afterInvoiceAddressChanged', {detail: this.billingAddressId}));
                }, error => {

                });

            if (this.hasToValidate) {
                this.validate();
            }
        },

        validate() {

            const showError = this.billingAddressId <= 0;

            this.$store.commit('setInvoiceAddressShowError', showError);

            if (showError) {
                NotificationService.error(
                    TranslationService.translate('Ceres::Template.checkoutCheckInvoiceAddress')
                );
            }
        }
    },

    watch: {
        billingAddressId() {
            if (this.hasToValidate && this.showError) {
                this.validate();
            }
        }
    }
});
